export default __webpack_public_path__ + "static/media/b1.9e6c4bdc.svg";